<template>
    <div>
        <h5>Count 组件</h5>
        <p>count 的值是： {{ count }}</p>
        <button @click="add">+1</button>
    </div>
</template>

<script>
    export default {
        name: "",
        props: {
            // 自定义属性
            init: {
              default: 0,
                 type: Number
            }
        },
        data() {
            return {
                count: this.init
            }
        },
        methods: {
            add() {
                this.count += 1
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
